import { useContext } from "react";
import { ScrollContext } from "../contexts/ScrollContext";

export function useScroll() {
    const value = useContext(ScrollContext);
    return value;
}